// extracted by mini-css-extract-plugin
module.exports = {"CampaignHeader":"styles_CampaignHeader__DwSXm"};